var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tech"},[_c('i',{class:_vm.techClass,attrs:{"title":_vm.techTitle,"aria-hidden":"true"}}),_c('p',[_vm._v(" "+_vm._s(_vm.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }